export default "__VITE_ASSET__DunQ$Pv9__"